import React from 'react'
import { Loader2, AlertTriangle } from 'lucide-react'
import { PodcastStatusEnum, type PodcastStatusValue } from '../../../../types/enums'

export const AudioStatusIndicator: React.FC<{ 
  hasAudio: boolean; 
  isProcessing: boolean;
  status?: PodcastStatusValue;
}> = ({ hasAudio, isProcessing, status }) => {
  // Each pill hides text on small screens and shows from md breakpoint.
  // Screen readers still get full label via aria-label.

  if (status === PodcastStatusEnum.Failed) {
    return (
      <div
        className="inline-flex items-center gap-1.5 rounded-full bg-danger-50 px-2 py-1 text-xs font-medium text-danger-700 ring-1 ring-inset ring-danger-600/20"
        aria-label="Failed"
      >
        <AlertTriangle className="h-3 w-3" />
        <span className="hidden sm:inline">Failed</span>
      </div>
    )
  }

  if (isProcessing) {
    return (
      <div
        className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2 py-1 text-xs font-medium text-amber-700 ring-1 ring-inset ring-amber-600/20 w-full whitespace-nowrap"
        aria-label="Generating"
      >
        <Loader2 className="h-3 w-3 animate-spin" />
        <span className="hidden sm:inline">Generating</span>
      </div>
    )
  }

  if (hasAudio) {
    return (
      <div
        className="inline-flex items-center gap-1.5 rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 w-full whitespace-nowrap"
        aria-label="Audio ready"
      >
        <div className="h-2 w-2 rounded-full bg-green-600" />
        <span className="hidden sm:inline">Audio ready</span>
      </div>
    )
  }

  return (
    <div
      className="inline-flex items-center gap-1.5 rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-300/50 w-full whitespace-nowrap"
      aria-label="No audio"
    >
      <div className="h-2 w-2 rounded-full bg-gray-400" />
      <span className="hidden sm:inline">No audio</span>
    </div>
  )
}
